// "max" metadata checks real number patterns; the default "min" set only checks length (e.g. accepts 8-digit 11119999 for India)
import { getExampleNumber, isValidPhoneNumber, validatePhoneNumberLength } from "libphonenumber-js/max";
import examples from "libphonenumber-js/examples.mobile.json";
import en from "react-phone-number-input/locale/en";

const getExampleDigits = (countryIso) => {
  try {
    return getExampleNumber(countryIso, examples)?.nationalNumber?.length || null;
  } catch {
    return null;
  }
};

// Validates a national phone number (digits only) against the selected country's length and format rules.
// Returns an error message, or null when valid.
export const getPhoneValidationError = (phoneValue, countryIso, callingCode) => {
  const phone = (phoneValue || "").trim();
  if (!phone) return "Phone number is required.";

  const fullNumber = `+${callingCode}${phone}`;
  const country = en[countryIso] || "the selected country";
  const digits = getExampleDigits(countryIso);
  const hint = digits ? ` (usually ${digits} digits)` : "";

  // Uses the country's real allowed lengths, so countries with several valid lengths aren't rejected
  switch (validatePhoneNumberLength(fullNumber)) {
    case "TOO_SHORT":
      return `Phone number is too short for ${country}${hint}.`;
    case "TOO_LONG":
      return `Phone number is too long for ${country}${hint}.`;
    case "INVALID_LENGTH":
      return `Phone number length is not valid for ${country}${hint}.`;
    case "NOT_A_NUMBER":
    case "INVALID_COUNTRY":
      return "Enter a valid phone number.";
    default:
      break;
  }

  if (!isValidPhoneNumber(fullNumber)) {
    // Right length but not a real number pattern (e.g. Indian numbers can't start with 1)
    if (digits && phone.length === digits) {
      return `Not a valid ${country} phone number. Please check the starting digits.`;
    }
    return `Enter a valid phone number for ${country}${hint}.`;
  }

  return null;
};
